/**
 * @generated SignedSource<<43763e7c525eba6690e1c61eba4400bf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PersonCell_user$data = {
  readonly name: string | null;
  readonly email: string | null;
  readonly entityId: string;
  readonly avatarUrl: string | null;
  readonly " $fragmentType": "PersonCell_user";
};
export type PersonCell_user = PersonCell_user$data;
export type PersonCell_user$key = {
  readonly " $data"?: PersonCell_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PersonCell_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PersonCell_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "shape",
          "value": "SQUARE"
        }
      ],
      "kind": "ScalarField",
      "name": "avatarUrl",
      "storageKey": "avatarUrl(shape:\"SQUARE\")"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "7e3c49c409a005e59ffeff2a4439e9f3";

export default node;
